import { useTranslation } from 'react-i18next';
import style from './ReturnButton.module.scss';
import userIcon from '../../assets/pictures/icons/user-icon.svg';

export const ReturnButton = () => {
    const { t } = useTranslation('general');
    const VISPER_VIDEO_URL = process.env.NX_PUBLIC_VISPER_VIDEO_URL || "";

    return (
        <a href={`${VISPER_VIDEO_URL}/profile`} className={style.returnButton}>
            <img src={userIcon} alt='Personal icon' className={style.returnButtonImg} />
            <span className={style.returnButtonText}>{t("personal_account")}</span>
        </a>
    );
};